// predetermined error codes agreed uppon with backend
export const serverErrorCodes = {
  ATTRIBUTE_UNIQUE_CONSTRAINT: 'ATTRIBUTE_UNIQUE_CONSTRAINT',
  // Login
  HTTP_UNAUTHORIZED: 'HTTP_UNAUTHORIZED',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LOGIN_ERROR_BETA: 'LOGIN_ERROR_BETA',
  AUTHORIZATION_MISSING_ERROR: 'AUTHORIZATION_MISSING_ERROR',
  CUSTOMER_MISSING_ERROR: 'CUSTOMER_MISSING_ERROR',
  MAX_LOGIN_ATTEMPTS: 'MAX_LOGIN_ATTEMPTS',
  IDENTITY_PROVIDER_NOT_ALLOWED: 'IDENTITY_PROVIDER_NOT_ALLOWED',
  IDENTIY_PROVIDER_EMAIL_NOT_VERIFIED: 'IDENTIY_PROVIDER_EMAIL_NOT_VERIFIED',
  // Shares
  SHARELINK_PASSWORD_HEADER_MISSING: 'SHARELINK_PASSWORD_HEADER_MISSING',
  SHARELINK_PASSWORD_INCORRECT: 'SHARELINK_PASSWORD_INCORRECT',
  SHARELINK_ALREADY_GRANTED: 'SHARELINK_ALREADY_GRANTED',
  HTTP_NOT_FOUND: 'HTTP_NOT_FOUND',
  // Downloads
  ASSET_NUMBER_ERR: 'EXCEEDING_MAX_ASSET_COUNT',
  DOWNLOAD_SIZE_ERR: 'EXCEEDING_MAX_SIZE',
  DOWNLOAD_NO_FILES: 'DOWNLOAD_NO_FILES',
  // Workspace members
  INVITE_TOKEN_EXPIRED_ERROR: 'INVITE_TOKEN_EXPIRED_ERROR',
  INVITE_TOKEN_INVALID_ERROR: 'INVITE_TOKEN_INVALID_ERROR',
  INVITE_TOKEN_ACCEPTED_ERROR: 'INVITE_TOKEN_ACCEPTED_ERROR',
  INVITE_USER_DATA_ERROR: 'INVITE_USER_DATA_ERROR',
  NOT_ALLOWED_LAST_ADMIN: 'NOT_ALLOWED_LAST_ADMIN',
  WORKSPACE_FULL: 'WORKSPACE_FULL',
  WORKSPACE_ALREADY_MEMBER: 'WORKSPACE_ALREADY_MEMBER',
  // Workspace teams
  DUPLICATE_NAME: 'HTTP_CONFLICT',
  // 2FA login
  OTP_CODE_INVALID: 'OTP_CODE_INVALID'
} as const;

export type ServerErrorCode =
  (typeof serverErrorCodes)[keyof typeof serverErrorCodes];

// error codes for use with redux form validators
export const validationErrorCodes = {
  ERROR_REQUIRED: 'ERROR_REQUIRED',
  REQUIRED_ERROR: 'REQUIRED_ERROR',
  EMAIL_SYNTAX_ERROR: 'EMAIL_SYNTAX_ERROR',
  WEAK_PASSWORD_ERROR_LENGTH: 'WEAK_PASSWORD_ERROR_LENGTH',
  MAXIMUM_PASSWORD_ERROR_LENGTH: 'MAXIMUM_PASSWORD_ERROR_LENGTH',
  WEAK_PASSWORD_ERROR_CONSECUTIVE: 'WEAK_PASSWORD_ERROR_CONSECUTIVE',
  WEAK_PASSWORD_ERROR_SEQUENTIAL: 'WEAK_PASSWORD_ERROR_SEQUENTIAL',
  WEAK_PASSWORD_ERROR_DICTIONARY: 'WEAK_PASSWORD_ERROR_DICTIONARY',
  SHOULD_MATCH_VALUE: 'SHOULD_MATCH_VALUE',
  DUPLICATE_RECIPIENTS_ERROR: 'DUPLICATE_RECIPIENTS_ERROR',
  INVALID_RECIPIENTS_ERROR: 'INVALID_RECIPIENTS_ERROR',
  // 2fa login
  INVALID_ENROLL_CODE_ERROR: 'INVALID_ENROLL_CODE_ERROR'
};
